/**
 * Browser-specific messages for a `fetch()` that never received an HTTP response —
 * the connection dropped, the request was aborted, or the tab was backgrounded
 * mid-request. Apollo surfaces these as an unhandled `ApolloError` with no
 * `statusCode` (no response came back).
 *
 * This predicate only identifies the message class; it does NOT decide on its own
 * that an error is benign. The same messages on a foregrounded tab can signal a
 * real outage, broken CORS, or a misconfigured endpoint. The caller pairs this
 * with a `view.in_foreground === false` check before dropping the event.
 */
const BENIGN_NETWORK_ERROR_MESSAGES = [
  'NetworkError when attempting to fetch resource', // Firefox
  'Failed to fetch', // Chrome / Edge
  'Load failed', // Safari
  'The network connection was lost', // Safari
]

interface IsBenignNetworkErrorParams {
  message: string
}

export const isBenignNetworkError = ({ message }: IsBenignNetworkErrorParams): boolean =>
  BENIGN_NETWORK_ERROR_MESSAGES.some((benignMessage) => message.includes(benignMessage))
